module.exports = __webpack_public_path__ + "img/swipetable-grayscale.d75ebcbc.gif";